<template>
  <div class="lock">
    <div class="list">
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          :height="tableHeight"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-if="tableListData.rows && tableListData.rows.length > 0"
          v-loading="tableLoading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column label="id" prop="lockId"></el-table-column>
          <!-- <el-table-column label="车位号" prop="attr7"></el-table-column> -->
          <!-- <el-table-column label="网关编号" prop="gatewayId"></el-table-column> -->

          <!-- <el-table-column label="设备版本" prop="lockVersions">
            </el-table-column> -->
          <el-table-column label="锁名称" prop="lockName"> </el-table-column>

          <el-table-column label="锁编号" prop="lockCode"> </el-table-column>
          <el-table-column label="锁类型" prop="lockType"></el-table-column>

          <el-table-column label="泊位号" prop="attr7"> </el-table-column>
          <el-table-column label="信号强度" prop="rssi"> </el-table-column>
          <el-table-column label="电量" prop="voltage"> </el-table-column>

          <!-- <el-table-column label="升锁设置" prop=""> </el-table-column> -->
          <!-- <el-table-column label="心跳时间" prop=""> </el-table-column> -->
          <el-table-column label="告警" prop="alarm"> </el-table-column>
          <el-table-column label="最后通信时间" prop="finalTime" width="150">
          </el-table-column>
          <el-table-column label="锁状态" prop="lockStatus" width="120">
            <template slot-scope="scope">
              <el-tag
                :type="getStatusType(scope.row.lockStatus).type"
                :style="{
                  backgroundColor: getStatusType(scope.row.lockStatus).color,
                  borderColor: getStatusType(scope.row.lockStatus).color,
                  color: '#fff',
                }"
                size="small"
              >
                {{ getStatusType(scope.row.lockStatus).text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="车位状态"
            prop="parkingSpaceStatus"
            width="120"
          >
            <template slot-scope="scope">
              <el-tag
                :type="getSpaceStatusType(scope.row.parkingSpaceStatus).type"
                :style="{
                  backgroundColor: getSpaceStatusType(
                    scope.row.parkingSpaceStatus
                  ).color,
                  borderColor: getSpaceStatusType(scope.row.parkingSpaceStatus)
                    .color,
                  color: '#fff',
                }"
                size="small"
              >
                {{ getSpaceStatusType(scope.row.parkingSpaceStatus).text }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="异常"> </el-table-column> -->
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <button
                class="edit"
                type="button"
                @click="addOrEdit(scope.row.lockId)"
              >
                修改
              </button>
              <button
                class="delete"
                @click="del(scope.row.lockId)"
                type="button"
              >
                删除
              </button>
              <el-dropdown @command="handleCommand">
                <span
                  style="
                    font-size: 12px;
                    color: #409eff;
                    margin-left: 4px;
                    cursor: pointer;
                  "
                >
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :disabled="scope.row.lockStatus == '00'"
                    :command="{ type: 'up', ...scope.row }"
                    >升锁</el-dropdown-item
                  >
                  <el-dropdown-item
                    :disabled="scope.row.lockStatus == '11'"
                    :command="{ type: 'down', ...scope.row }"
                    >降锁</el-dropdown-item
                  >
                  <el-dropdown-item :command="{ type: 'reset', ...scope.row }"
                    >复位</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-else
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <el-empty description="请先选择左侧的停车场"></el-empty>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <Page v-on:pagination="receivePaginationData"></Page>
    </div>

    <!--添加/修改锁-->
    <el-dialog
      ref="park"
      :title="editOrAddForm.lockId ? '修改锁' : '添加锁'"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="500px"
      @open="openDialog"
      @close="closeDialog"
      class="dialog-lock"
    >
      <el-form
        :model="editOrAddForm"
        :rules="editOrAddFormRules"
        ref="editOrAddFormV"
      >
        <el-form-item
          label="锁名称"
          :label-width="formLabelWidth"
          prop="lockName"
        >
          <el-col :span="18">
            <el-input v-model="editOrAddForm.lockName" placeholder="请输入锁名称"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="锁编号"
          :label-width="formLabelWidth"
          prop="lockCode"
        >
          <el-col :span="18">
            <el-input v-model="editOrAddForm.lockCode" placeholder="请输入锁编号"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="锁类型"
          :label-width="formLabelWidth"
          prop="lockType"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.lockType" placeholder="请选择锁类型" style="width: 100%;">
              <el-option label="U型车锁" value="U型车锁"></el-option>
              <el-option label="平板车锁" value="平板车锁"></el-option>
              <el-option label="地埋车锁" value="地埋车锁"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="通讯类型"
          :label-width="formLabelWidth"
          prop="communicationType"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.communicationType" placeholder="请选择通讯类型" style="width: 100%;">
              <el-option label="4G" value="4G"></el-option>
              <el-option label="LORA&基站" value="LORA&基站"></el-option>
              <el-option label="NB-IOT" value="NB-IOT"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="检测方式"
          :label-width="formLabelWidth"
          prop="detectionMethod"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.detectionMethod" placeholder="请选择检测方式" style="width: 100%;">
              <el-option label="地磁+微波" value="地磁+微波"></el-option>
              <el-option label="地感线圈" value="地感线圈"></el-option>
              <el-option label="地磁微波+地感" value="地磁微波+地感"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="电池类型"
          :label-width="formLabelWidth"
          prop="batteryType"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.batteryType" placeholder="请选择电池类型" style="width: 100%;">
              <el-option label="三元锂电池" value="三元锂电池"></el-option>
              <el-option label="铅酸电池" value="铅酸电池"></el-option>
              <el-option label="磷酸铁锂电池" value="磷酸铁锂电池"></el-option>
              <el-option label="市电" value="市电"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="安装类型"
          :label-width="formLabelWidth"
          prop="installationType"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.installationType" placeholder="请选择安装类型" style="width: 100%;">
              <el-option label="嵌入式" value="嵌入式"></el-option>
              <el-option label="地面式" value="地面式"></el-option>
              <el-option label="半嵌入式" value="半嵌入式"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const LOCK_ALARM = {
  1: "打开",
  0: "关闭",
};
const LOCK_FORARM_BLOCK = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_POWER = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_TIME = {
  "000": "不自动升",
  "001": "2分钟",
  "010": "5分钟",
  "011": "15分钟",
  100: "30分钟",
  101: "60分钟",
};
const LOCK_HEARTBEAT = {
  "000": "1分钟",
  "001": "5分钟",
  "010": "10分钟",
  "011": "30分钟",
  100: "60分钟",
  101: "2小时",
  110: "3小时",
  111: "4小时",
};
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  shareParks,
  locks,
  lockDetail,
  addLock,
  updateLock,
  deleteLock,
  upLock,
  downLock,
  resetLock,
  gatewaysByParkingId,
} from "@/api/url";

import Page from "@/page/commons/page";
import AreaTree from "@/page/commons/parking/commons/areaTree.vue";

export default {
  props: [
    "parkingId",
    "gatewayId",
    "lockType",
    "lockCode",
    "spaceNum",
    "lockStatus",
  ],
  data() {
    return {
      lockAlarm: { ...LOCK_ALARM },
      lockForarmBlock: { ...LOCK_FORARM_BLOCK },
      lockPower: { ...LOCK_POWER },
      lockTime: { ...LOCK_TIME },
      lockHeartbeat: { ...LOCK_HEARTBEAT },
      dialogFormVisible: false,

      park: "",

      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      editOrAddForm: {
        lockId: null,
        lockName: "",
        lockCode: "",
        lockType: "",
        communicationType: "",
        detectionMethod: "",
        batteryType: "",
        installationType: "",
      },

      editOrAddFormRules: {
        lockName: [
          { required: true, message: "请输入锁名称", trigger: "blur" }
        ],
        lockCode: [
          { required: true, message: "请输入锁编号", trigger: "blur" }
        ],
        lockType: [
          { required: true, message: "请选择锁类型", trigger: "change" }
        ],
      },
      formLabelWidth: "100px",
      allOrderType: [],
      moduleName: "",
      temp: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        devStatu: "",
        devNum: "",
        //transNum:'',
        //startTime:"",
        //endTime:""
      },
      downloadFileds: {
        地磁编号: "onerankdevDevSn",
        网关编号: {
          field: "attr7",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).stationSn
              : "";
          },
        },
        泊位编号: {
          field: "attr8",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).spaceNum
              : "";
          },
        },
        停车道路: {
          field: "attr2",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).parkingName
              : "";
          },
        },
        泊位段: {
          field: "attr3",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).areaName
              : "";
          },
        },
        最后通讯时间: "lastFlowDate",
        地磁状态: "attr1",
        通信频率: "loraid",
      },
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},
      shareParksData: [],
      gateways: [],
      tableLoading: false,
      tableHeight: 400, // 表格高度，动态计算
      selectedRows: [], // 选中的行
    };
  },
  mounted() {
    console.log("list mounted");
    this.calculateTableHeight();
    window.addEventListener("resize", this.calculateTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateTableHeight);
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    params() {
      return {
        parkingId: this.parkingId || undefined,
        gatewayId: this.gatewayId || undefined,
      };
    },
  },

  watch: {
    params: {
      handler(newVal, oldVal) {
        this.tableListData.rows = [];
        console.log("list newVal", newVal);
        // 不再强制要求选择停车场，直接查询
        this.search.pageNumber = 1;
        this.tableList(1);
      },
      immediate: true, // 改为 true，组件挂载时立即触发
      deep: true,
    },
    // 监听查询条件变化
    lockType() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },
    lockCode() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },
    spaceNum() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },
    lockStatus() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },
    // 监听数据变化，重新计算表格高度
    "tableListData.rows"() {
      this.$nextTick(() => {
        this.calculateTableHeight();
      });
    },
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList(curPage) {
      console.log("list", curPage);
      var _this = this;
      _this.tableListData.rows = [];
      _this.tableLoading = true;

      // 构建查询参数
      const params = {
        limit: this.search.pageSize,
        page: curPage,
      };
      
      // 如果提供了停车场ID，则添加到查询参数中
      if (this.parkingId) {
        params.parkingId = this.parkingId;
      }
      if (this.gatewayId) {
        params.gatewayId = this.gatewayId;
      }

      // 添加查询条件（从 props 获取）
      if (this.lockType) {
        params.lockType = this.lockType;
      }
      if (this.lockCode) {
        params.lockCode = this.lockCode;
      }
      if (this.spaceNum) {
        params.spaceNum = this.spaceNum;
      }
      if (this.lockStatus) {
        params.lockStatus = this.lockStatus;
      }

      // 暂时直接使用测试数据（开发测试用）
      // 如果需要使用真实 API，可以注释掉下面这行，取消注释后面的 API 调用
      _this.loadTestData();
      _this.tableLoading = false;
      return;
      
      // 真实 API 调用（暂时注释）
      // this.$postRequest(locks(), params)
      //   .then((data) => {
      //     if (data.status != 200) {
      //       // 如果请求失败，使用测试数据
      //       _this.loadTestData();
      //       return;
      //     }
      //     //翻页
      //     var pageObj = {
      //       curIndex: data.data.offset,
      //       rowsCount: data.data.total,
      //     };
      //     _this.getPage(pageObj);
      //     console.log(data.data.rows);
      //     
      //     // 如果返回的数据为空，使用测试数据
      //     if (!data.data.rows || data.data.rows.length === 0) {
      //       _this.loadTestData();
      //     } else {
      //       _this.tableListData.rows = data.data.rows;
      //     }
      //     
      //     _this.$nextTick(() => {
      //       _this.calculateTableHeight();
      //       if (_this.$refs.table) {
      //         _this.$refs.table.doLayout();
      //       }
      //     });
      //   })
      //   .catch((error) => {
      //     // 请求失败时使用测试数据
      //     console.error("加载数据失败，使用测试数据:", error);
      //     _this.loadTestData();
      //   })
      //   .finally(() => {
      //     _this.tableLoading = false;
      //   });
    },

    // 加载测试数据
    loadTestData() {
      const testData = [
        {
          lockId: 1,
          lockName: "测试锁001",
          lockCode: "LOCK001",
          lockType: "U型车锁",
          attr7: "A001",
          rssi: -75,
          voltage: 3.8,
          alarm: "",
          finalTime: "2024-01-15 10:30:00",
          lockStatus: "在线",
          parkingSpaceStatus: "空闲",
        },
        {
          lockId: 2,
          lockName: "测试锁002",
          lockCode: "LOCK002",
          lockType: "平板车锁",
          attr7: "A002",
          rssi: -82,
          voltage: 3.5,
          alarm: "电量偏低",
          finalTime: "2024-01-15 10:25:00",
          lockStatus: "在线",
          parkingSpaceStatus: "使用中",
        },
        {
          lockId: 3,
          lockName: "测试锁003",
          lockCode: "LOCK003",
          lockType: "地埋车锁",
          attr7: "A003",
          rssi: -95,
          voltage: 3.2,
          alarm: "",
          finalTime: "2024-01-15 09:15:00",
          lockStatus: "离线",
          parkingSpaceStatus: "空闲",
        },
        {
          lockId: 4,
          lockName: "测试锁004",
          lockCode: "LOCK004",
          lockType: "U型车锁",
          attr7: "B001",
          rssi: -88,
          voltage: 3.6,
          alarm: "挡板异常",
          finalTime: "2024-01-15 11:00:00",
          lockStatus: "故障",
          parkingSpaceStatus: "空闲",
        },
        {
          lockId: 5,
          lockName: "测试锁005",
          lockCode: "LOCK005",
          lockType: "平板车锁",
          attr7: "B002",
          rssi: -70,
          voltage: 4.0,
          alarm: "",
          finalTime: "2024-01-15 11:05:00",
          lockStatus: "在线",
          parkingSpaceStatus: "使用中",
        },
        {
          lockId: 6,
          lockName: "测试锁006",
          lockCode: "LOCK006",
          lockType: "地埋车锁",
          attr7: "B003",
          rssi: -100,
          voltage: 3.0,
          alarm: "电量过低",
          finalTime: "2024-01-15 08:30:00",
          lockStatus: "离线",
          parkingSpaceStatus: "空闲",
        },
        {
          lockId: 7,
          lockName: "测试锁007",
          lockCode: "LOCK007",
          lockType: "U型车锁",
          attr7: "C001",
          rssi: -78,
          voltage: 3.7,
          alarm: "",
          finalTime: "2024-01-15 10:50:00",
          lockStatus: "在线",
          parkingSpaceStatus: "空闲",
        },
        {
          lockId: 8,
          lockName: "测试锁008",
          lockCode: "LOCK008",
          lockType: "平板车锁",
          attr7: "C002",
          rssi: -85,
          voltage: 3.4,
          alarm: "通讯异常",
          finalTime: "2024-01-15 09:45:00",
          lockStatus: "故障",
          parkingSpaceStatus: "使用中",
        },
        {
          lockId: 9,
          lockName: "测试锁009",
          lockCode: "LOCK009",
          lockType: "地埋车锁",
          attr7: "C003",
          rssi: -92,
          voltage: 3.3,
          alarm: "",
          finalTime: "2024-01-15 10:10:00",
          lockStatus: "离线",
          parkingSpaceStatus: "空闲",
        },
        {
          lockId: 10,
          lockName: "测试锁010",
          lockCode: "LOCK010",
          lockType: "U型车锁",
          attr7: "D001",
          rssi: -68,
          voltage: 3.9,
          alarm: "",
          finalTime: "2024-01-15 11:15:00",
          lockStatus: "在线",
          parkingSpaceStatus: "使用中",
        },
      ];
      
      this.tableListData.rows = testData;
      // 设置分页信息
      const pageObj = {
        curIndex: 1,
        rowsCount: testData.length,
      };
      this.getPage(pageObj);
      
      // 更新表格布局
      this.$nextTick(() => {
        this.calculateTableHeight();
        if (this.$refs.table) {
          this.$refs.table.doLayout();
        }
      });
    },
    
    // 查询（供父组件调用）
    handleSearch() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },

    // 重置（供父组件调用）
    handleReset() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },

    addOrEdit(id) {
      this.dialogFormVisible = true;
      if (id) {
        // 修改模式
        this.$get(`${lockDetail()}/${id}`).then((data) => {
          if (data.status != 200) {
            this.$message.error(data.message);
            return;
          }
          const lockData = data?.data ?? {};
          this.editOrAddForm = {
            lockId: lockData.lockId || id,
            lockName: lockData.lockName || "",
            lockCode: lockData.lockCode || lockData.lockSn || "",
            lockType: lockData.lockType || "",
            communicationType: lockData.communicationType || lockData.attr1 || "",
            detectionMethod: lockData.detectionMethod || lockData.attr2 || "",
            batteryType: lockData.batteryType || lockData.attr3 || "",
            installationType: lockData.installationType || lockData.attr4 || "",
          };
        });
      } else {
        // 添加模式
        this.editOrAddForm = {
          lockId: null,
          lockName: "",
          lockCode: "",
          lockType: "",
          communicationType: "",
          detectionMethod: "",
          batteryType: "",
          installationType: "",
        };
      }
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs["editOrAddFormV"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          
          const formData = {
            lockName: _this.editOrAddForm.lockName,
            lockCode: _this.editOrAddForm.lockCode,
            lockType: _this.editOrAddForm.lockType,
            communicationType: _this.editOrAddForm.communicationType,
            detectionMethod: _this.editOrAddForm.detectionMethod,
            batteryType: _this.editOrAddForm.batteryType,
            installationType: _this.editOrAddForm.installationType,
          };
          
          if (_this.editOrAddForm.lockId) {
            // 修改模式
            _this
              .$putRequest(updateLock(), {
                lockId: _this.editOrAddForm.lockId,
                ...formData,
              })
              .then((data) => {
                if (data.status !== 200)
                  return _this.$message.error(data.message);
                _this.$notify({
                  type: "success",
                  message: "修改成功！",
                  title: "成功",
                });
                _this.tableList(_this.curIndex);
              });
          } else {
            // 添加模式
            const addParams = {
              ...formData,
            };
            // 如果提供了停车场ID和网关ID，则添加到参数中
            if (_this.parkingId) {
              addParams.parkingId = _this.parkingId;
            }
            if (_this.gatewayId) {
              addParams.gatewayId = _this.gatewayId;
            }
            _this
              .$postRequest(addLock(), addParams)
              .then((data) => {
                if (data.status !== 200)
                  return _this.$message.error(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功！",
                  title: "成功",
                });
                _this.tableList(1);
              });
          }
        }
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["editOrAddFormV"].resetFields();
    },
    del: function (id) {
      var _this = this;

      var index = _this.$layer.confirm(
        "您确定删除该设备吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this.$deleteRequest(`${deleteLock()}/${id}`).then((data) => {
            if (data.status != 200) return _this.$message.error(data.message);

            _this.$notify({
              type: "success",
              message: "删除成功！",
              title: "成功",
            });
            _this.tableList(_this.curIndex);
          });
        }
      );
    },
    //   handleTreeClick: function(node) {
    //     // 如果节点类型为停车场
    //     if (node.type === "parking") {
    //       this.search.parkingId = node.id;
    //       this.onParkChange(node.id);
    //       // 获取数据
    //       this.tableList(this.search.pageNumber);
    //     } else this.search.parkingId = undefined;
    //   },
    //   searchList: function() {
    //     if (!this.search.parkingId)
    //       return this.$message({ type: "error", message: "请先选择停车场" });
    //     this.search.pageNumber = 1;
    //     this.tableList(this.search.pageNumber);
    //   },

    //   getShareParks() {
    //     this.search.gatewayId = "";
    //     this.editOrAddForm.gatewayId = "";
    //     this.$postRequest(shareParks(), {}).then((data) => {
    //       this.shareParksData = data?.data?.data?.rows ?? [];
    //     });
    //   },
    async handleCommand(command) {
      console.log("command=>", command);
      const { type, gatewayId, lockId, lockCode } = command;
      switch (type) {
        case "up": {
          const res = await this.$postRequest(
            `${upLock()}?lockCode=${lockCode}`
          );
          if (res.status === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.tableList(this.curIndex);
          } else {
            this.$message.error(res.message);
          }
          break;
        }

        case "down": {
          const res = await this.$postRequest(
            `${downLock()}?lockCode=${lockCode}`
          );
          if (res.status === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.tableList(this.curIndex);
          } else {
            this.$message.error(res.message);
          }
          break;
        }
        case "reset": {
          const res = await this.$postRequest(
            `${resetLock()}?lockCode=${lockCode}`
          );

          if (res.status === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.tableList(this.curIndex);
          } else {
            this.$message.error(res.message);
          }
          break;
        }
      }
    },
    //   getGateways(id) {
    //     this.$get(`${gatewaysByParkingId()}/${id}`).then((data) => {
    //       this.gateways = data?.data ?? [];
    //     });
    //   },
    //   onParkChange(val) {
    //     this.getGateways(val);
    //   },

    // 计算表格高度
    calculateTableHeight() {
      this.$nextTick(() => {
        const container = this.$el?.querySelector(".list-right");
        if (container) {
          // 减去分页器高度（约60px）和其他间距
          const containerHeight = container.clientHeight;
          // 分页器高度约60px，加上一些边距
          this.tableHeight = containerHeight - 70;
          // 确保最小高度
          if (this.tableHeight < 200) {
            this.tableHeight = 200;
          }
        }
      });
    },

    // 获取设备状态类型和颜色
    getStatusType(status) {
      if (!status) return { type: "info", color: "#909399", text: "未知" };

      const statusStr = status.toString().toLowerCase();

      // 在线状态 - 绿色
      if (
        statusStr.includes("在线") ||
        statusStr === "在线" ||
        statusStr === "normal" ||
        statusStr === "正常" ||
        statusStr === "00" ||
        statusStr === "01"
      ) {
        return { type: "success", color: "#67C23A", text: "在线" };
      }

      // 离线状态 - 橙色
      if (
        statusStr.includes("离线") ||
        statusStr === "离线" ||
        statusStr === "offline"
      ) {
        return { type: "warning", color: "#E6A23C", text: "离线" };
      }

      // 故障状态 - 红色
      if (
        statusStr.includes("故障") ||
        statusStr === "故障" ||
        statusStr === "error" ||
        statusStr === "异常" ||
        statusStr === "11"
      ) {
        return { type: "danger", color: "#F56C6C", text: "故障" };
      }

      // 待机状态 - 蓝色
      if (
        statusStr.includes("待机") ||
        statusStr === "待机" ||
        statusStr === "standby"
      ) {
        return { type: "info", color: "#409EFF", text: "待机" };
      }

      // 维护状态 - 灰色
      if (
        statusStr.includes("维护") ||
        statusStr === "维护" ||
        statusStr === "maintenance"
      ) {
        return { type: "info", color: "#909399", text: "维护" };
      }

      // 默认返回信息类型
      return { type: "info", color: "#909399", text: status };
    },

    // 获取车位状态类型和颜色
    getSpaceStatusType(status) {
      if (!status) return { type: "info", color: "#909399", text: "未知" };

      const statusStr = status.toString().toLowerCase();

      // 使用中/占用 - 橙色
      if (
        statusStr.includes("使用") ||
        statusStr.includes("占用") ||
        statusStr === "使用中" ||
        statusStr === "占用" ||
        statusStr === "occupied" ||
        statusStr === "inuse"
      ) {
        return { type: "warning", color: "#E6A23C", text: "使用中" };
      }

      // 空闲 - 绿色
      if (
        statusStr.includes("空闲") ||
        statusStr === "空闲" ||
        statusStr === "空闲中" ||
        statusStr === "available" ||
        statusStr === "free"
      ) {
        return { type: "success", color: "#67C23A", text: "空闲" };
      }

      // 预约 - 蓝色
      if (
        statusStr.includes("预约") ||
        statusStr === "预约" ||
        statusStr === "reserved"
      ) {
        return { type: "info", color: "#409EFF", text: "预约" };
      }

      // 故障 - 红色
      if (
        statusStr.includes("故障") ||
        statusStr === "故障" ||
        statusStr === "error"
      ) {
        return { type: "danger", color: "#F56C6C", text: "故障" };
      }

      // 默认返回信息类型
      return { type: "info", color: "#909399", text: status };
    },
    
    // 选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      // 通知父组件选中状态变化
      this.$emit('selection-change', selection);
    },
  },

  components: {
    Page,
    AreaTree,
  },
};
</script>

<style scoped>
/* @import '@/assets/css/equip.css'; */
.lock {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.lock .list {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.list-right {
  height: 100%;
  display: flex;
  flex-direction: column;
  /* padding: 20px; */
  padding-bottom: 100px; /* 增加底部内边距，为分页组件留出足够空间 */
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.pagination-wrapper {
  position: absolute;
  bottom: 10px;
  right: 20px;
  background: white;
  padding: 10px 15px;
  z-index: 10;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.btns {
  margin: 20px auto 0;
  width: 150px;
}

table td label {
  margin-bottom: 0 !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  border-radius: 1px;
}
.boxbgcolor {
  display: flex;
}
.battery {
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.electricity {
  display: flex;
  justify-content: center;
  align-items: center;
}
.lock .form-control {
  height: 26px;
}
</style>
<style>
.lock .dialog-lock .el-select {
  display: block;
}
</style>
